import NewsViewer from "@components/newsViewer/newsViewer";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { GetNewsDetailResponse } from "src/core/news";
import { useGetNewsDetail } from "src/hooks";

const NewsDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [news, setNews] = useState<GetNewsDetailResponse | null>(null);

  const { getDetail, loading } = useGetNewsDetail();

  useEffect(() => {
    const fetchNewsDetail = async () => {
      try {
        const response = await getDetail(id as string);
        setNews(response);
      } catch (error) {
        console.error("Error fetching news details:", error);
      }
    };
    if (id) {
      fetchNewsDetail();
    }
  }, [id]);

  if (!news) return <p>Cargando...</p>;

  return <NewsViewer news={news} />;
};

export default NewsDetail;
